import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    private authService = inject(AuthService);
    // canActivate is called by Angular's router to determine if a route can be activated
    // It checks if the user has a token by verifying the presence of an auth token
    // Returns true if user has a token, false otherwise
    // @param route - Contains the route information being activated
    // @param state - Contains the router state information
    // @returns Promise<boolean> - Whether the route can be activated
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.authService.isLoggedIn();
    }
}
